import script from "./IfNode.vue?vue&type=script&setup=true&lang=js"
export * from "./IfNode.vue?vue&type=script&setup=true&lang=js"

import "./IfNode.vue?vue&type=style&index=0&id=b655592a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b655592a"]])

export default __exports__